import { useRef } from "react";

export const useHookOption = <R>(data: R) => {
  const handlersRef = useRef(data);
  handlersRef.current = data;
  return handlersRef;
};
